import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ShariahServiceProvider } from '../../providers/shariah-service/shariah-service';

/**
 * Generated class for the AboutusPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-aboutus',
  templateUrl: 'aboutus.html',
})

export class AboutusPage {
  about: string;
  img: string;
  slides: any[];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private shariahService: ShariahServiceProvider
  ) {
    this.slides = [
      { image: 'assets/imgs/about-us-01.png' },
      { image: 'assets/imgs/about-us-02.png' },
      { image: 'assets/imgs/about-us-03.png' },
    ];
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AboutusPage');
  }

  async ngOnInit() {
    await this.getAboutUs();

    this.slides = [
      { image: 'assets/imgs/about-us-01.png' },
      { image: 'assets/imgs/about-us-02.png' },
      { image: 'assets/imgs/about-us-03.png' },
    ];
  }

  async getAboutUs() {
    await this.shariahService.getAboutUs().subscribe((data: any) => this.img = data.about_img, err => console.log(err));
  }
}



// WEBPACK FOOTER //
// ./src/pages/aboutus/aboutus.ts